import { type OrganizationDataSourceAccount } from '@libraries/typescript/api_client';

export type EhrCaregiverFieldVisibility = {
    readonly showCaregiverStatus: boolean;
    readonly showCompliance: boolean;
};

/** Show fields only when at least one configured EHR populates them. */
export function getEhrCaregiverFieldVisibility(
    dataSourceAccounts: Array<OrganizationDataSourceAccount> | undefined,
): EhrCaregiverFieldVisibility {
    const hhaexchangeSettings = dataSourceAccounts?.find(
        (candidate) => candidate.type === 'hhaexchange',
    )?.source_account_settings;
    const wellskySettings = dataSourceAccounts?.find(
        (candidate) => candidate.type === 'wellsky',
    )?.source_account_settings;

    return {
        showCaregiverStatus:
            (hhaexchangeSettings?.type === 'hhaexchange' &&
                hhaexchangeSettings.include_non_terminated_caregivers_as_active ===
                    true) ||
            (wellskySettings?.type === 'wellsky' &&
                wellskySettings.sync_inactive_caregivers_as_active === true),
        showCompliance:
            hhaexchangeSettings?.type === 'hhaexchange' &&
            hhaexchangeSettings.caregiver_compliance_sync_enabled === true,
    };
}
